const h = (e, t) => {
  let n = [];
  for (let r = 0; r <= Math.floor(t.length / e); r++)
    t.slice(r * e, e * (r + 1)).length && n.push(t.slice(r * e, e * (r + 1)));
  return n;
}, m = (e) => {
  if (e === "" || e === void 0 || e === null) return "";
  const [t, n] = e.split(":");
  return `${Number.parseInt(t, 10) * 60 + Number.parseInt(n, 10)} MIN`;
}, w = (e) => {
  if (e == null) return "";
  const t = Math.floor(e / 60), n = e % 60, r = t > 0 ? `${t} HR${t > 1 ? "S" : ""}` : "", s = n > 0 ? `${n} MIN${n > 1 ? "S" : ""}` : "";
  return `${r} ${s}`;
}, $ = (e) => {
  const [t, n] = e.split(" ");
  let [r, s] = t.split(":");
  return r === "12" && (r = "00"), n === "PM" && (r = parseInt(r, 10) + 12), r.length === 1 && (r = `0${r}`), `${r}:${s}`;
}, v = (e) => e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, ""), y = (e = "") => {
  const t = e.replace(/\D/ig, "");
  let n = "";
  return t.length > 0 && t.length < 3 && (n = `(${t}`), t.length >= 3 && t.length < 6 && (n = `(${t.slice(0, 3)}) ${t.slice(3, 6)}`), t.length >= 6 && (n = `(${t.slice(0, 3)}) ${t.slice(3, 6)}-${t.slice(6)}`), n;
}, b = (e = []) => e.flat().filter((t) => t && typeof t == "string").join(" "), T = (e) => {
  const t = Object.keys(e).filter((n) => !!e[n]);
  return t.length ? "?" + t.map((n) => `${n}=${encodeURIComponent(e[n])}`).join("&") : "";
};
function A(e, t = 650, n = 450, r = "no", s = "no", o = "no") {
  const l = window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - t / 2, c = window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - n / 2, u = {
    height: n,
    width: t,
    left: l,
    top: c,
    location: r,
    toolbar: "no",
    status: "no",
    directories: "no",
    menubar: s,
    scrollbars: "yes",
    resizable: o,
    centerscreen: "yes",
    chrome: "yes"
  };
  return window.open(
    e,
    "share",
    Object.keys(u).map((a) => `${a}=${u[a]}`).join(",")
  );
}
const C = (e) => e.split("_").map((t) => t.charAt(0).toUpperCase() + t.slice(1).toLowerCase()).join("");
function P(e) {
  const t = e.split(" "), n = [t[0].toLowerCase()];
  for (let r = 1; r < t.length; r++)
    n.push(t[r].charAt(0).toUpperCase() + t[r].slice(1).toLowerCase());
  return n.join("");
}
const S = (e) => {
  if (e && (e.__typename === "SeriesItem" || e.__typename === "MovieItem") && e.slug && !e.preventDetailPage) {
    let t = "";
    switch (e.__typename) {
      case "SeriesItem":
        t = "show/" + e.slug;
        break;
      case "MovieItem":
        t = "movie/" + e.slug;
        break;
    }
    return t;
  }
  return "";
}, E = (e) => {
  var t, n;
  return e != null && e.altTextOverride ? e.altTextOverride : (n = (t = e == null ? void 0 : e.image) == null ? void 0 : t[0]) != null && n.alt ? e.image[0].alt : "";
}, M = () => "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0, _ = (e = []) => {
  const t = setInterval(() => {
    document.body && (clearInterval(t), e.forEach((s) => {
      const { id: o } = s;
      document.getElementById(o) || r({ ...s }).then(() => {
        console.log("Script tag added successfully");
      }).catch((c) => {
        n("Error adding script tag", c);
      });
    }));
  }, 100), n = (s, o) => {
    console.warn(s), console.error(o);
  }, r = ({
    id: s,
    src: o = null,
    textContent: l = null,
    async: c = !1,
    defer: u = !1,
    insertInHead: p = !1
  }) => new Promise((a, f) => {
    !o && !l && f(), o && l && f();
    const i = document.createElement("script"), d = () => {
      i.removeEventListener("load", d), a();
    }, g = () => {
      i.removeEventListener("error", g), f();
    };
    o !== null && typeof o == "string" && i.setAttribute("src", o), i.textContent = l !== null && typeof l == "string" ? l : null, s !== null && typeof s == "string" && i.setAttribute("id", s), c && i.setAttribute("async", c), u && i.setAttribute("defer", u), i.addEventListener("load", d), i.addEventListener("error", g), p ? document.head.appendChild(i) : document.body.appendChild(i);
  });
};
export {
  y as areaCodePhoneNumberMask,
  h as chunkArray,
  b as classes,
  $ as convert12to24,
  _ as createScriptTags,
  S as generateHrefFromProgramSlug,
  w as getHoursMinsStr,
  m as getMinutesFromStr,
  M as isTouchDevice,
  T as objectToGetParams,
  E as setAltText,
  v as slugify,
  C as snakeToPascal,
  P as stringToCamelCase,
  A as windowOpen
};
